var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrendUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2452 20.1157C31.1402 19.8607 30.9302 19.6507 30.6752 19.5457C30.5552 19.5007 30.4202 19.4707 30.2852 19.4707H27.4952C26.9102 19.4707 26.4452 19.9357 26.4452 20.5207C26.4452 21.1057 26.9102 21.5707 27.4952 21.5707H27.7652L24.6002 24.7357L23.0702 22.4557C22.8902 22.2007 22.6202 22.0207 22.3052 21.9907C21.9752 21.9607 21.6902 22.0657 21.4652 22.2907L16.9952 26.7607C16.5902 27.1657 16.5902 27.8257 16.9952 28.2457C17.2052 28.4557 17.4602 28.5457 17.7302 28.5457C18.0002 28.5457 18.2702 28.4407 18.4652 28.2457L22.0352 24.6757L23.5652 26.9557C23.7452 27.2107 24.0152 27.3907 24.3302 27.4207C24.6602 27.4507 24.9452 27.3457 25.1702 27.1207L29.2502 23.0407V23.3107C29.2502 23.8957 29.7152 24.3607 30.3002 24.3607C30.8852 24.3607 31.3502 23.8957 31.3502 23.3107V20.5057C31.3202 20.3707 31.3052 20.2357 31.2452 20.1157Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trendUp.413075f635642910c8b17be083f4eccf.svg";
export { ForwardRef as ReactComponent };